<template>
  <el-dialog
    title="分享题目"
    width="630px"
    :visible="visible"
    @close="visible = false"
  >
    <div class="content">
      <div class="link-wrap">
        <div>复制链接，向小伙伴分享本题</div>
        <div class="ipt-wrap">
          <el-input readonly :value="h5Link" />
        </div>
        <div style="margin-top: 10px">
          <el-button
            style="height: 42px; width: 220px; border-radius: 22px;"
            type="primary"
            @click="handleCopy"
            >一键复制</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import copyText from '@/utils/clipboard'

export default {
  data() {
    return {
      visible: false,
      pracitceData: 0
    }
  },
  computed: {
    h5Link() {
      const { id } = this.pracitceData
      return `https://weixin.ptego.com/#/pages/exp/index?id=${id}`
    }
  },
  methods: {
    open(item) {
      console.log(item)
      this.pracitceData = item
      this.visible = true
    },
    handleCopy() {
      copyText(this.h5Link)

      this.$message.success('复制成功')
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  color: #1f1f40;
  font-size: 14px;
  text-align: center;
  padding-bottom: 30px;

  .title {
    color: #1f1f40;
    font-size: 14px;
  }

  > img {
    width: 110px;
    height: 110px;
    margin-top: 18px;
  }

  .tip {
    color: #9e9e9e;
  }

  .link-wrap {
    margin-top: 20px;
    text-align: center;

    .ipt-wrap {
      display: flex;
      align-items: center;
      margin-top: 10px;

      ::v-deep .el-button {
        margin-left: 10px;
        background-color: #3b86ff;
        border-color: #3b86ff;
        min-width: 100px;
      }
    }
  }
}
</style>
